import { render, staticRenderFns } from "./S2S_adv.vue?vue&type=template&id=20e62a2c&"
import script from "./S2S_adv.vue?vue&type=script&lang=js&"
export * from "./S2S_adv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports